<div class="faq-container" [class.arebic-content]="textDirection == 'rtl'">
    <div class="col-5 faq">
        <div class="faq-block">
            <h4 class="title" translate>HOME_PAGE.FAQ_TITLE</h4>
            <!-- <p translate>HOME_PAGE.FAQ_DESC</p> -->

            <button routerLink="/faq-shopper"  class="btn btn-outline" translate> HOME_PAGE.ALL_FAQ </button>
        </div>
        <div class="faq-block-resp">
            <h4 class="title" translate>HOME_PAGE.ANS_FAQ</h4>
            <a translate routerLink="/faq-shopper" >HOME_PAGE.SEE_ALL</a>
        </div>
    </div>
    <div class="col-5" >
        <div class="faq-ques">
            <div class="card">
                <taly-custom-accordion [items]="faqList" />
            </div>
        </div>
    </div>
</div>